export default __webpack_public_path__ + "static/bronco-bbfb8cdde73efb71810ae5792f38ec1f.png";